import { parseMatrixStringValue } from "../../services/helpers.service"

export const getEnumKey = (enumValue: string | null, EnumTypes: any) => {
  if (!enumValue) return null
  return Object.keys(EnumTypes)[Object.values(EnumTypes).indexOf(enumValue)]
}

export const checkValidQueriedValueOfType = (
  queryValue: string | null,
  Type: any
) => {
  if (!queryValue) return
  const key = queryValue as keyof typeof Type
  return Type[key]
}

export const checkValidQueriedValueOfSecuringMethod = (
  queryValue: string | null,
  Type: any
) => {
  if (!queryValue) return
  return parseMatrixStringValue(queryValue)
}
